/* eslint-disable no-undef */
import axios from 'axios';

import { isBrowserWindow } from './browserWindow';

export const parseAPIBaseName = (endPoint) => {
  if (isBrowserWindow()) return '';

  const serverConfigs = {
    customer: process.env.RAZZLE_TX_API_CUSTOMER_SERVICE,
    'product-view': process.env.RAZZLE_TX_API_PRODUCT_VIEW_SERVICE,
    content: process.env.RAZZLE_TX_API_CONTENT_SERVICE,
    reporting: process.env.RAZZLE_TX_API_REPORTING_SERVICE,
  };

  const serviceName = endPoint.split('/')[3];

  return serviceName ? serverConfigs[serviceName] || process.env.RAZZLE_TX_DOMAIN : process.env.RAZZLE_TX_DOMAIN;
};

const parseParams = (params) => {
  const keys = Object.keys(params);
  let options = '';

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === 'object';

    if (!isParamTypeObject && typeof params[key] !== 'undefined' && params[key] !== '') {
      options += `${key}=${params[key]}&`;
    }

    if (isParamTypeObject && params[key] != null && params[key].length >= 0) {
      params[key].forEach((element) => {
        options += `${key}=${element}&`;
      });
    }
  });

  return options ? options.slice(0, -1) : options;
};

export const apiCall = async ({ endPoint, method, payload, headers, params }) => {
  const baseUrl = isBrowserWindow() ? process.env.RAZZLE_TX_CLIENT_DOMAIN : process.env.RAZZLE_TX_DOMAIN;
  try {
    const result = await axios({
      method,
      baseURL: baseUrl,
      url: endPoint,
      headers,
      data: payload,
      params,
      paramsSerializer: (params) => parseParams(params),
    });
    return {
      response: result,
      error: null,
    };
  } catch (e) {
    return {
      response: null,
      error: { ...e.request, status: e?.response?.status },
    };
  }
};

export const apiCallPromise = ({ endPoint, method, payload, headers, params }) => {
  const baseUrl = parseAPIBaseName(endPoint); // used on server so it need to parse endPoint
  return axios({
    method,
    baseURL: baseUrl,
    url: endPoint,
    headers,
    data: payload,
    params,
  })
    .then((result) => ({
      response: result,
      error: null,
      // eslint-disable-next-line prefer-promise-reject-errors
    }))
    .catch((e) =>
      // eslint-disable-next-line prefer-promise-reject-errors
      Promise.reject({
        response: null,
        error: e.request,
      }),
    );
};
